import React, { useRef, useState } from "react";
import { Play, RotateCcw, VideoOff } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { resolveImg } from "@/lib/utils";

export const inr = (v) => `₹${Number(v || 0).toLocaleString("en-IN")}`;
export const themeWord = (t = "") => t.charAt(0) + t.slice(1).toLowerCase();
export const ctaName = (m) => (m.name || "").replace(/\s+Meditation$/i, "");

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

// Purchase CTAs open the shared checkout (MeditationCheckoutHost).
export const CHECKOUT_EVENT = "ic-meditation-checkout";
const openCheckout = (p) => p && window.dispatchEvent(new CustomEvent(CHECKOUT_EVENT, { detail: p }));
export const meditationActions = {
  buy: openCheckout,
  buyCollection: openCheckout,
};

export function PreviewButton({ m }) {
  const [open, setOpen] = useState(false);
  const [ended, setEnded] = useState(false);
  const ref = useRef(null);
  const src = resolveImg(m.preview_video_url);
  if (!src) {
    return (
      <span className="inline-flex items-center gap-2 text-sm text-[#9C928D]" data-testid={`preview-unavailable-${m.slug}`}>
        <VideoOff size={16} /> Preview coming soon
      </span>
    );
  }
  const replay = () => { setEnded(false); if (ref.current) { ref.current.currentTime = 0; ref.current.play(); } };
  return (
    <>
      <button type="button" onClick={() => { setEnded(false); setOpen(true); }} data-testid={`play-preview-${m.slug}`}
        className="inline-flex items-center gap-2 text-sm font-medium text-terracotta hover:text-[#C2654C] transition-colors">
        <span className="w-9 h-9 rounded-full bg-[#E07A5F]/10 flex items-center justify-center"><Play size={15} className="ml-0.5" /></span>
        Play Preview
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="w-[94vw] sm:max-w-2xl p-4 sm:p-6" data-testid={`preview-modal-${m.slug}`}>
          <DialogHeader>
            <DialogTitle className="font-serif text-2xl text-left">{m.name}</DialogTitle>
            <DialogDescription className="text-left">{m.subtitle} · 20-second preview</DialogDescription>
          </DialogHeader>
          <video ref={ref} src={src} controls autoPlay playsInline preload="metadata" onEnded={() => setEnded(true)}
            className="w-full rounded-2xl bg-black max-h-[70vh]" data-testid={`preview-video-${m.slug}`} />
          {ended && (
            <button type="button" onClick={replay} className="btn-ghost self-start" data-testid={`preview-replay-${m.slug}`}>
              <RotateCcw size={15} className="mr-2" /> Replay preview
            </button>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}

export function SectionHead({ title, sub, id, className = "" }) {
  return (
    <div id={id} className={`scroll-mt-24 ${className}`}>
      <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#2D2422] leading-tight">{title}</h2>
      {sub && <p className="mt-3 text-base sm:text-lg text-[#7E736E] font-light max-w-2xl">{sub}</p>}
    </div>
  );
}
